'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	config = require('@mindmup/config'),
	AjaxPromise = require('../models/ajax-promise'),
	authenticationAWSStart = require('../features/authentication/authentication-aws-start'),
	cognitoStart = require('../features/cognito/cognito-start'),
	defaultMapContent = require('../models/default-map-content'),
	GoldAWSApi = require('../models/gold-aws-api'),
	GoldFilesPageController = require('../models/gold-files-page-controller'),
	NavigatorShim  = require('../widgets/navigator-shim'),
	personalSignupStart = require('../features/signup/personal-signup-start'),
	S3Api = require('../models/s3-api'),
	S3FileModel = require('../models/s3-file-model'),
	pageActionsStart = require('../features/page-actions-start'),
	SubscriptionPlanModel = require('../models/subscription-plan-model'),
	fileImportStart = require('../features/file-import/file-import-aws-start'),
	GoldFilePicker = require('../models/gold-file-picker'),
	MapSharingModel = require('../models/map-sharing-model'),
	ConfigurationGenerator = require('../models/configuration-generator'),
	GoldMapCreatorModel = require('../models/gold-map-creator-model'),
	goldFileListStart = require('../features/gold-file-list/gold-file-list-start'),
	SubteamApi = require('../models/sub-team-api'),
	plans = require('../models/plans'),
	{ initGAConsent } = require('./ga-consent');


require('../widgets/user-profile-widget');
require('../widgets/visibility-observer');
require('../widgets/menu-bar-widget');
require('../widgets/macify-hotkeys-widget');
require('../widgets/install-hotkey-widget');
require('../widgets/show-hotkey-widget');
require('../widgets/subscription-profile-widget');
require('../widgets/context-menu-widget');
require('../widgets/context-disabler-widget');
require('../widgets/contact-link-widget');
require('../widgets/gold-map-sharing-widget');
require('../widgets/drive-open-link-widget');
require('../widgets/tabbed-section-widget');

module.exports = function editorAWS() {
	const navigatorShim = new NavigatorShim(),
		storage = navigatorShim.getJsonStorage(),
		subscriptionPlanModel = new SubscriptionPlanModel(plans(config.allowedAccountTypes)),
		ajaxPromise = new AjaxPromise(navigatorShim),
		goldApi = new GoldAWSApi(ajaxPromise, config.goldAWSApiUrl),
		authentication = authenticationAWSStart(config, goldApi, navigatorShim, window, ajaxPromise),
		s3Api = new S3Api(navigatorShim, ajaxPromise),
		s3FileModel = new S3FileModel(config, authentication, goldApi, s3Api, navigatorShim, defaultMapContent),
		cognito = cognitoStart(config, goldApi, authentication.subscriptionModel, authentication.authenticationModel, authentication.reauthenticator, navigatorShim),
		goldFileList = goldFileListStart(config, storage, s3FileModel, navigatorShim),
		filePicker = new GoldFilePicker(navigatorShim),
		configurationGenerator = new ConfigurationGenerator(goldApi, authentication.authenticationModel),
		fileImport = fileImportStart(config, filePicker, authentication.subscriptionModel, navigatorShim, s3FileModel, configurationGenerator, s3Api, goldApi),
		pageController = new GoldFilesPageController(goldFileList.goldFileListModel, authentication.authenticationModel, fileImport.importModel, navigatorShim, authentication.subscriptionModel),
		subteamApi = new SubteamApi(authentication, goldApi, s3Api),
		mapSharingModel = new MapSharingModel(pageController, s3FileModel, subteamApi),
		mapCreatorModel = new GoldMapCreatorModel(config, navigatorShim),
		components = Object.assign({
			mapCreatorModel: mapCreatorModel,
			mapSharingModel: mapSharingModel,
			importModel: fileImport.importModel,
			cognito: cognito,
			goldFileListModel: goldFileList.goldFileListModel,
			pageController: pageController
		}, authentication),
		container = document.querySelector('[data-mm-role~="fileList"]');
	personalSignupStart(config, authentication.subscriptionModel, subscriptionPlanModel, authentication.authenticationModel, navigatorShim, s3Api, goldApi);
	initGAConsent(config);
	pageActionsStart(components, container);

	authentication.authenticationModel.addEventListener('authenticatedProfile not-authenticated', (reason) => {
		if (reason === 'signed-out') {
			navigatorShim.redirect('/');
			return;
		}
	});
	goldFileList.initialiseWidgets(authentication.authenticationModel);
	fileImport.initialiseWidgets();
	mmWidgets('[data-mm-context-menu-context]').contextDisablerWidget(goldFileList.goldFileListModel, 'toggleContextMenu', 'data-mm-context-menu-context');
	mmWidgets('contextmenu[data-mm-role~="file-context"]').contextMenuWidget(goldFileList.goldFileListModel, mmWidgets('[data-mm-role~="file-scroller"]'), mmWidgets('body'), {contextMenuEvent: 'toggleContextMenu', smallContexts: []});
	mmWidgets('[data-mm-hotkey]').macifyHotkeys(navigatorShim);
	mmWidgets('mapmenu').menuBarWidget(navigatorShim);
	mmWidgets('[data-mm-show-hotkey]').showHotkeyWidget(mmWidgets('body'));
	mmWidgets('[data-mm-install-hotkey]').installHotkeyWidget();
	mmWidgets('[data-mm-subscription-profile]').subscriptionProfileWidget(authentication.subscriptionModel);
	mmWidgets('[data-mm-map-sharing-context]').contextDisablerWidget(mapSharingModel, 'context', 'data-mm-map-sharing-context');
	mmWidgets('#gold-map-sharing-modal').goldMapSharingWidget(mapSharingModel);
	mmWidgets('[data-mm-role~="openGDriveMap"]').driveOpenLinkWidget(config, navigatorShim);
	mmWidgets('[data-mm-role="contactLink"]').contactLinkWidget(config, navigatorShim);
	mmWidgets('tabbedsection').tabbedSectionWidget();
	window.components = components;
	authentication.reauthenticator.reauthenticate().catch(() => {
		if (navigatorShim.getQueryStringAsMap().auth === 'microsoft') {
			mmWidgets('.auth-choice').toggleClass('auth-microsoft');
			mmWidgets('[data-mm-role~=microsoft-authentication-dialog]').removeClass('hidden');
		}
	});
};

